import { css } from 'styled-components';
import { rem, media } from '../../../helpers/mixins';
import { PINK, WHITE, PURPLE_LIGHT } from '../../../constants/colors';


export default {
  wrapper: ({ disableButton }) => css`
    display: flex;
    position: relative;
    overflow: hidden;
    margin-right: 26px;
    width: 100px;
    height: 32px;
    border-radius: 4px;
    transform: translate3d(0, 0, 0);
    cursor: pointer;

    ${media.sm`
      margin-right: 0;
    `}

    ${disableButton && css`
      opacity: 0.7;
    `}
  `,
  continueBuyWrapper: ({ isBuying, isCancel }) => css`
    display: flex;
    color: ${WHITE};
    width: 200px;
    height: 32px;
    font-size: ${rem('16px')};
    line-height: ${rem('32px')};
    transition: transform 0.3s ease-in-out;
    will-change: transform;
    transform: translate3d(-100px, 0, 0);

    ${isBuying && css`
      transform: translate3d(-200px, 0, 0);
    `}

    ${isCancel && css`
      transform: translate3d(0, 0, 0);
    `}
  `,
  cancel: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 100px;
    height: 32px;
    background-color: ${PURPLE_LIGHT};
  `,
  continue: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 100px;
    height: 32px;
    background-color: ${PINK};
  `,
  buy: css`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 100px;
    height: 32px;
    background-color: rgba(0, 128, 0, 0.4);
  `,
  buyPercentage: ({ progress }) => css`
    position: absolute;
    background-color: green;
    top: 0;
    left: 0;
    width: ${progress || 0}%;
    height: 33px;
    transition: width 0.5s linear;
  `,
  buyLabel: css`
    z-index: 2;
  `
};
